// Wspólny klient REST panelu. Dotychczas każda strona nosiła własną kopię `adminHeaders` +
// `adminFetch` (osiem identycznych par); nowe strony filtrów korzystają z tej jednej —
// naturalne miejsce, żeby przy okazji przenosić tu kolejne.

export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000";

function adminHeaders(): Record<string, string> {
  const token = localStorage.getItem("access_token");
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  return headers;
}

/**
 * Żądanie do `/api/v1/admin/...` z tokenem admina.
 *
 * Komunikat błędu bierzemy z pola `error` odpowiedzi — backend wkłada tam walidację po
 * polsku (np. „Nieznane kryterium filtra…”), a to jedyna informacja, po której support
 * pozna, czemu zapis nie przeszedł.
 */
export async function adminFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const url = path.startsWith("http") ? path : `${API_URL}/api/v1/admin/${path.replace(/^\/+/, "")}`;
  const response = await fetch(url, {
    ...init,
    headers: { ...adminHeaders(), ...init?.headers },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(error.error || `Request failed: ${response.statusText}`);
  }
  return response.json() as Promise<T>;
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : "Wystąpił nieoczekiwany błąd.";
}
